module.exports = __webpack_public_path__ + "static/media/dark_mathnasium.afd2bca0.png";